// vim: set ts=2 sw=2 et tw=80 ft=javascript:
/**
 * Copyright (C) 2016 Minted Inc.
 * All Rights Reserved
 * CTAG:COMMUNITY:STORES
 */

var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_',
  'minted:config/stores_shared_constants_config': []
})(this, function (m_module, Backbone, $, _) {

  "use strict";

  var M = m_module.M;
  M.Community = M.Community || {};
  M.Community.View = M.Community.View || {};
  M.Config = M.Config || {};

  var errorDict = M.Config['StoresSharedConstantsConfig']['validation_error'];

  M.Community.Model.CurateLink = Backbone.Model.extend({

    idAttribute: 'sku',

    // TODO: pass in from context variable
    // http://jira.minted.com/browse/CM-9495
    urlRoot: '/product/curate',

    initialize: function() {
      M.required(this.get('sku'));
    },

    toggleCurate: function() {
      this.save({is_curated: !this.get('is_curated')},
        { success: this._handleAppResponse,
          error: this._handleHttpError});
    },

    isCurated: function() {
      return this.get('is_curated');
    },

    _handleAppResponse: function(model) {
      var errorCode = model.get('error_code');
      if (errorCode !== errorDict['no_error']['error_code']) {
        model.trigger('curate_exception');
      }
    },

    _handleHttpError: function(model, response, options) {
      this.model.set('is_curated', !this.model.get('is_curated'));
    }

  });

  return {
  };

});
